import { FaTools, FaCogs, FaWrench, FaHeadset, FaCheckCircle, FaWhatsapp, FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import '../styles/home.css';

const Home = () => {
  const services = [
    {
      icon: <FaTools className="service-icon service-icon--blue" />,
      title: 'Sales',
      description: 'Wide range of high-quality jikos and motor equipment for all your needs.'
    },
    {
      icon: <FaCogs className="service-icon service-icon--red" />,
      title: 'Installation',
      description: 'Professional installation services by certified technicians.'
    },
    {
      icon: <FaWrench className="service-icon service-icon--green" />,
      title: 'Maintenance',
      description: 'Regular maintenance to keep your equipment running smoothly.'
    },
    {
      icon: <FaHeadset className="service-icon service-icon--yellow" />,
      title: '24/7 Support',
      description: 'Round-the-clock customer support for all your queries.'
    }
  ];

  const features = [
    { icon: <FaCheckCircle className="feature-check-icon" />, text: 'Quality Products' },
    { icon: <FaCheckCircle className="feature-check-icon" />, text: 'Certified Technicians' },
    { icon: <FaCheckCircle className="feature-check-icon" />, text: 'Affordable Prices' },
    { icon: <FaCheckCircle className="feature-check-icon" />, text: 'Timely Service' },
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="home-hero">
        <div className="hero-decoration"></div>
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title">Efficient Energy Saving Jikos</h1>
            <p className="hero-subtitle">
              Revolutionary stoves that are economic, sustainable & efficient for institutions Heads & managers, hospitals, hotels 
                and any other consumer of our Products.
            </p>
            <div className="hero-buttons">
              <a href="#services" className="hero-button hero-button--primary">Our Services</a>
              <a href="/contact" className="hero-button hero-button--secondary">Contact Us</a>
            </div>
          </div>
          <div className="hero-image">
            <img 
              src="/main-30020be7-7b72-470c-97d3-25555f2094ff.png" 
              alt="Jiko and motor equipment"
              className="hero-img"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section" id="services">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Our Services</h2>
            <div className="section-divider"></div>
            <p className="section-subtitle">
              We are committed to providing the best quality products and services to our customers.
            </p>
          </div>
          
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-card__icon">
                  {service.icon}
                </div>
                <h3 className="service-card__title">{service.title}</h3>
                <p className="service-card__description">{service.description}</p>
                <a href="./services" className="service-card__link">
                  Learn more <FaArrowRight className="service-card__arrow" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section" id="about">
        <div className="section-container">
          <div className="about-content">
            <div className="about-content__text">
              <h2 className="section-title">About Joewaki Motor Agency Limited</h2>
              <div className="section-divider"></div>
              <p className="about-content__description">
                Joewaki Motor Agency Limited is a leading provider of high-quality jikos and motor equipment in the region. 
                With years of experience, we have built a reputation for excellence in sales, installation, and maintenance services.
              </p>
              <div className="features-list">
                {features.map((feature, index) => (
                  <div key={index} className="features-list__item">
                    <span className="features-list__icon">{feature.icon}</span>
                    <span className="features-list__text">{feature.text}</span>
                  </div>
                ))}
              </div>
              <Link to="/about" className="cta-button">
                Learn More About Us <FaArrowRight className="cta-button__icon" />
              </Link>
            </div>
            <div className="about-content__image">
              <img
                src="/variety-a3fa5177-0eea-404b-83ce-2b0f5b6cede4.png"
                alt="Professional technicians at work"
                className="about-image"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="section-container">
          <div className="cta-content">
            <h2 className="cta-content__title">Ready to Get Started?</h2>
            <p className="cta-content__description">
              Contact us today for all your jiko and motor equipment needs. Our team is ready to assist you with expert advice and professional service.
            </p>
            <div className="cta-buttons">
              <a
                href="https://wa.me/254721858828"
                target="_blank"
                rel="noopener noreferrer"
                className="cta-button cta-button--primary"
              >
                <FaWhatsapp className="cta-button__icon" /> Chat on WhatsApp
              </a>
              <a
                href="tel:+254721858828"
                className="cta-button cta-button--secondary"
              >
                Call Us Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
